import {
    CompanyPartnersResponse,
    GetWarehouseProductsResponse,
    GetWarehouseRootCategoriesResponse,
    GetWarehouseSubcategoriesResponse,
    UserType,
} from './dataTypes';

export const mockGetWarehouseRootCategoriesResponse: GetWarehouseRootCategoriesResponse =
    {
        categories: Array.from({length: 4}, (_, i) => ({
            id: i + 1,
            code: `root${i + 1}`,
            name: `Root Category ${i + 1}`,
            productsCount: 76,
            productsTotalCount: 76,
            categoriesCount: 10,
            categories: Array.from({length: 10}, (_, j) => ({
                id: j + 1 + 10 * (i + 1),
                code: `sub${j + 1 + 10 * (i + 1)}`,
                name: `Subcategory ${j + 1 + 10 * (i + 1)}`,
                productsCount: 76,
                productsTotalCount: 76,
                categoriesCount: 5,
            })),
        })),
    };

export const getMockGetWarehouseSubcategoriesResponse = (
    categoryId: number,
): GetWarehouseSubcategoriesResponse => {
    return {
        category: {
            id: categoryId,
            code: `sub${categoryId}`,
            name: `Subcategory ${categoryId}`,
            productsCount: 76,
            productsTotalCount: 76,
            categoriesCount: 10,
        },
        subcategories: Array.from({length: 10}, (_, i) => ({
            id: categoryId * 10 + i + 1,
            code: `sub${categoryId * 10 + i + 1}`,
            name: `Subcategory ${categoryId * 10 + i + 1}`,
            productsCount: 76,
            productsTotalCount: 76,
            categoriesCount: categoryId * 10 + i + 1 > 1000 ? 0 : 10,
        })),
    };
};

export const getMockGetWarehouseProductsResponse = ({
    categoryId,
    page,
    sortType,
}: {
    categoryId: number;
    page: number;
    sortType: string;
}): GetWarehouseProductsResponse => {
    return {
        category: {
            id: categoryId,
            code: `sub${categoryId}`,
            name: `Subcategory ${categoryId}`,
            productsCount: 100,
            productsTotalCount: 100,
            categoriesCount: 5,
        },
        products: Array.from({length: 10}, (_, i) => ({
            id: parseInt(`${categoryId}77${i + 1}${page}`),
            marking: `${parseInt(`${categoryId}77${i + 1}`)}`,
            picture: `https://cdn.klenmarket.ru/1359569301/hostcmsfiles/cache/upload/default_shop_item/8/4/4/item_8446/shop_items_catalog_image8446b3fcb097fab289c45c57f219c27d26d2.jpg`,
            url: `https://www.klenmarket.ru/shop/furniture/skladnaia-banketnaia-mebel/skl_stol/stol-plastikovyi-skladnoi-1204nm/`,
            name: `Product ${parseInt(`${categoryId}77${i + 1}`)} - ${page} - sort(${sortType})`,
            price: 10000 * i * 1,
            price_old: 10000 * i * 0.9,
            remains: Math.floor(Math.random() * 10),
            onTheWay: Math.floor(Math.random() * 10),
        })),
        pagination: {
            currentPage: page,
            totalPages: 10,
            totalItems: 100,
        },
    };
};

export const mockCompanyPartners: CompanyPartnersResponse = {
    partner_name: 'Старая мельница',
    counterparties: [
        {
            id: 123,
            type: UserType.Legal,
            name: 'ООО «Буханка»',
            balance: 1000,
            members: [
                {
                    id: 123,
                    name: 'Константин',
                    surname: 'Эвкалиптов',
                    phone: '+7 950 650 70 80',
                    email: 'k.evkaliptov@yandex.ru',
                },
                {
                    id: 2,
                    name: 'Иван',
                    surname: 'Эвкалиптов',
                    phone: '+7 950 650 70 80',
                    email: 'k.evkaliptov@yandex.ru',
                },
            ],
            // documents: [
            //     {
            //         id: '1',
            //         file_name: 'Реквизиты ООО Буханка.pdf',
            //         url: 'https://www.klenmarket.ru/static/km2/build/img/bannr/expanding-november/bg@2x.webp',
            //     },
            // ],
        },
        {
            id: 2,
            type: UserType.Legal,
            name: 'ООО «Хипстерский крендель»',
            balance: -123300,
            members: [
                {
                    id: 3,
                    name: 'Сергей',
                    surname: 'Эвкалиптов',
                    phone: '+7 950 650 70 80',
                    email: 'k.evkaliptov@yandex.ru',
                },
                {
                    id: 4,
                    name: 'Владислав',
                    surname: 'Эвкалиптов',
                    phone: '+7 950 650 70 80',
                    email: 'k.evkaliptov@yandex.ru',
                },
                {
                    id: 5,
                    name: 'Олег',
                    surname: 'Эвкалиптов',
                    phone: '+7 950 650 70 80',
                    email: 'k.evkaliptov@yandex.ru',
                },
            ],
            documents: [
                {
                    id: 2,
                    file_name: 'Реквизиты ООО «Хипстерский крендель».pdf',
                    url: 'https://www.klenmarket.ru/static/km2/build/img/bannr/expanding-november/bg@2x.webp',
                },
            ],
        },
        {
            id: 3,
            type: UserType.Legal,
            name: 'ООО «Хипстерский крендель»',
            members: [
                {
                    id: 3,
                    name: 'Сергей',
                    surname: 'Эвкалиптов',
                    phone: '+7 950 650 70 80',
                    email: 'k.evkaliptov@yandex.ru',
                },
                {
                    id: 4,
                    name: 'Владислав',
                    surname: 'Эвкалиптов',
                    phone: '+7 950 650 70 80',
                    email: 'k.evkaliptov@yandex.ru',
                },
                {
                    id: 5,
                    name: 'Ivan',
                    surname: 'Эвкалиптов',
                    phone: '+7 950 650 70 80',
                    email: 'k.evkaliptov@yandex.ru',
                },
            ],
            documents: [],
        },
    ],
};
